var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFilePlus = function SvgFilePlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 14,
    fill: "none",
    viewBox: "0 0 10 12"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#191F2E",
    d: "M5 4.875c.207 0 .375.168.375.375v1.125H6.5a.375.375 0 1 1 0 .75H5.375V8.25a.375.375 0 1 1-.75 0V7.125H3.5a.375.375 0 1 1 0-.75h1.125V5.25c0-.207.168-.375.375-.375"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#191F2E",
    d: "M9.5 3.375V10.5A1.5 1.5 0 0 1 8 12H2a1.5 1.5 0 0 1-1.5-1.5v-9A1.5 1.5 0 0 1 2 0h4.125zm-2.25 0A1.125 1.125 0 0 1 6.125 2.25V.75H2a.75.75 0 0 0-.75.75v9c0 .414.336.75.75.75h6a.75.75 0 0 0 .75-.75V3.375z"
  })));
};
export default SvgFilePlus;